/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-use-before-define */
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Page, TitleChapitre } from '@orientaction/components';
import clsx from 'clsx';
import { useState } from 'react';
import { imgBookIntro } from '../../../../utils/constants';

const Page13 = (props: any) => {
  const classes = useStyles();
  return (
    <Page id={13}>
      <TitleChapitre nbr={2} />
      <div>
        <div style={{ textAlign: 'center' }}>
          <Typography
            variant="h1"
            component="h1"
            color="primary"
            gutterBottom={true}
            className="opacity07">
            VOUS AVEZ RAISON DE VOULOIR CHANGER!
          </Typography>
        </div>
        <div className={clsx(classes.trait, classes.positionCenter)} style={{ marginTop: '50px', marginBottom: '50px' }} />
        <div>
          <Typography
            className={classes.paragraphe}
            style={{
              fontFamily: 'ITC Avant Garde Gothic Std Medium',
              marginTop: '50px',
              textAlign: 'justify',
              fontWeight: 'lighter',
            }}>
            Vous avez raison de vouloir changer et d’entreprendre cette démarche.
            <br />
            <br />
            Pourquoi?
            <br />
            <br />
            Parce que vous n’avez qu’une vie, qu’elle est courte, qu’elle est faite pour être
            heureux(se)!
            <br />
            <br />
            Parce que changer, c’est cool, excitant, amusant !
            <br />
            <br />
            Enfin, parce que changer, c’est bon pour la santé!
            <br />
            <br />
            On ne doit pas rester dans un métier, à un poste ou chez un employeur si l’on ne s’y
            sent pas bien !
            <br />
            <br />
            On ne doit pas accepter d’exercer un métier qui ne nous plaît pas.
            <br />
            <br />
            Nous ne devons pas accepter de souffrir, car nous n’avons qu’une vie, qu’elle est courte
            et que nous sommes fait(e)s pour être heureux(ses) !
          </Typography>
        </div>
      </div>
      <img
        src={`${imgBookIntro}/patissier.png`}
        alt="patissier"
        style={{
          width: '35%',
          display: 'block',
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: 20
        }}
      />
    </Page>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minWidth: 275,
      minHeight: '1000px',
      height: 'auto',
      padding: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    textCenterTop: {
      textAlign: 'center',
    },
    img: {
      width: '100%',
      height: 'auto',
    },
    trait: {
      backgroundColor: 'yellow',
      width: '75px',
      height: '5px',
      marginTop: '50px',
      marginBottom: '50px',
    },
    flexPosition: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    positionRelative: {
      position: 'relative',
    },
    positionAbsolute: {
      position: 'absolute',
    },
    opacity07: {
      opacity: 0.7,
    },
    logo: {
      width: '50%',
      height: 'auto',
      display: 'block',
      margin: 'auto',
    },
    paragraphe: {
      fontSize: '15px',
      color: 'black',
      lineHeight: 1.5,
      '@media only screen and (max-width: 600px)': {
        textAlign: 'left !important',
      },
      '@media only screen and (max-width: 361px)': {
        textAlign: 'left !important',
      },
    },
    positionCenter: {
      display: 'block',
      margin: 'auto',
    },
    cardBgGrey: {
      padding: 15,
      background: '#e8eef4',
    },
  })
);
export default Page13;
